import type { ReactNode } from "react";

/** Centred message used while the session is being established and on fatal auth errors. */
export function FullScreenMessage({
  title,
  description,
  action,
  testId,
}: {
  title: string;
  description?: string;
  action?: ReactNode;
  testId: string;
}) {
  return (
    <div className="flex h-full items-center justify-center p-8" data-testid={testId}>
      <div className="flex max-w-sm flex-col items-center gap-3 text-center">
        <h1 className="text-lg font-semibold">{title}</h1>
        {description ? <p className="text-sm text-muted-foreground">{description}</p> : null}
        {action}
      </div>
    </div>
  );
}
